var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigureGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.1808C6.2249 13.874 8.45368 13 11 13C13.5463 13 15.7751 13.874 17 15.1808C16.6808 15.5 12.6823 20.5 11 20.5C9.31766 20.5 5 15.1808 5 15.1808Z",
    fill: "#BCBEC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C11.7956 6 12.5587 6.31607 13.1213 6.87868C13.6839 7.44129 14 8.20435 14 9C14 9.79565 13.6839 10.5587 13.1213 11.1213C12.5587 11.6839 11.7956 12 11 12C10.2044 12 9.44129 11.6839 8.87868 11.1213C8.31607 10.5587 8 9.79565 8 9C8 8.20435 8.31607 7.44129 8.87868 6.87868C9.44129 6.31607 10.2044 6 11 6Z",
    fill: "#BCBEC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23223 2.47488C10.2085 1.49856 11.7915 1.49856 12.7678 2.47487L19.5251 9.23223C20.5014 10.2085 20.5014 11.7915 19.5251 12.7678L12.7678 19.5251C11.7915 20.5014 10.2085 20.5014 9.23223 19.5251L2.47488 12.7678C1.49856 11.7915 1.49856 10.2085 2.47487 9.23223L9.23223 2.47488Z",
    stroke: "#BCBEC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureGrey);
export default __webpack_public_path__ + "static/media/figure_grey.3d5b8f5e9666aef5dd75ac8995108805.svg";
export { ForwardRef as ReactComponent };